//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'WellsPE',
  data() {
    return {
      defaultJson:{
        "signshint": "下肢肿胀和深静脉触痛",
        "malignancyhint": "正在治疗或近 6个月内治疗过或姑息治疗",
      },
      form:{
        signs:'0',
        mostlikely:'0',
        tachycardia:'0',
        surgery:'0',
        previous:'0',
        hemoptysis:'0',
        malignancy:'0',
      },
      hasScore:false,
      disabled:false,
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.signs * 3 + form.mostlikely * 3 + form.tachycardia * 1.5 + form.surgery * 1.5 + form.previous * 1.5 + form.hemoptysis + form.malignancy
      self.hasScore = true
      if (result>6) {
        self.descTxt = '可能性：高'
      } else if(result<=2) {
        self.descTxt = '可能性：低'
      } else {
        self.descTxt = '可能性：中'
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/WellsPE.vue